<mat-card appearance="outlined" class="faxe-card">
  <h1 class="header">Administrera tävlingar</h1>
  <button
    type="submit"
    mat-raised-button
    color="primary"
    class="add-button"
    (click)="onAdd()"
  >
    Skapa
  </button>
  <faxe-table
    [data]="tableData"
    (inlineEditAction)="inlineEditAction($event)">
  </faxe-table>
</mat-card>
